"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var domElementHelper_1 = require("../helpers/domElementHelper");
function useToggleDomElementStyle(el) {
    react_1.useLayoutEffect(function () {
        var jivoWidget = document.querySelector('jdiv');
        if (el) {
            domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'add');
        }
        else {
            domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'remove');
        }
        return function () {
            domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'remove');
        };
    }, [el]);
}
exports.default = useToggleDomElementStyle;
